var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/flashOn.22a5ea40.png","uri@2x": __webpack_public_path__ + "static/media/flashOn.67b92dab.png","uri@3x": __webpack_public_path__ + "static/media/flashOn.b50c8a45.png",
    width: 18,
    height: 30
});